import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
    Box,
    Button,
    MenuItem,
    Stack,
    TextField,
    Typography,
    IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { DataGrid } from "@mui/x-data-grid";
import { GlobalState } from "context/GlobalContext";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import { AuthState } from "context/AuthContext";
import { roleAccess } from "../DiscountMasterList";
import { Discount_Master_Brands, DISOUNT_MASTER_CHANNEL_OPTIONS } from "../data";
import FileSaver from "file-saver";

const initialFormData = {
    channel: "",
    brand: "",
};

function DiscountStoreMaster() {
    const [formData, setFormData] = useState(initialFormData);
    const [storeRows, setStoreRows] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [file, setFile] = useState("");
    const [editingRowId, setEditingRowId] = useState(null);
    const [editContactNumber, setEditContactNumber] = useState("");
    const [editGrade, setEditGrade] = useState("");
    const [editStatus, setEditStatus] = useState("");
    const [editEmailValues, setEditEmailValues] = useState({});
    const [editEmailErrors, setEditEmailErrors] = useState({});

    const { user } = AuthState();
    const roleData = roleAccess(user);
    console.log("Sxnaksdjbjkasvbc", roleData)
    const role = ["VIEWER", "EDITOR"].includes(roleData.roles);
    const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

    const channelOptions = useMemo(
        () =>
            DISOUNT_MASTER_CHANNEL_OPTIONS.filter((item) =>
                roleData?.channelList?.includes(item.key)
            ),
        [roleData]
    );

    const brandOptions = useMemo(
        () =>
            Discount_Master_Brands.filter((item) =>
                roleData?.brandList?.includes(item.key)
            ),
        [roleData]
    );

    const filteredRows = useMemo(() => {
        const query = searchTerm.trim().toLowerCase();
        if (!query) return storeRows;

        return storeRows.filter((row) => {
            const valuesToSearch = [
                row?.store_name,
                row?.storeName,
                row?.ginesys_short_name,
                row?.partner_site_name,
                row?.store_grade,
                row?.grade,
                row?.status,
            ];

            return valuesToSearch.some((value) =>
                String(value || "").toLowerCase().includes(query)
            );
        });
    }, [storeRows, searchTerm]);

    const getContactValue = (row) =>
        row?.contact_no ||
        "";

    const getEmailValue = (row, field = "email") => row?.[field] || "";
    const getGradeValue = (row) => row?.grade || row?.store_grade || "";
    const getStatusValue = (row) => row?.status || "";

    const getEmailFields = useCallback(
        () =>
            formData.channel === "MBO"
                ? ["partner_email", "nsm_email", "zm_email", "rm_asm_email"]
                : ["email"],
        [formData.channel]
    );

    const handleEditStart = (row) => {
        setEditingRowId(row?._rowId);
        setEditContactNumber(getContactValue(row));
        setEditGrade(getGradeValue(row));
        setEditStatus(getStatusValue(row));
        setEditEmailValues(
            getEmailFields().reduce(
                (acc, field) => ({
                    ...acc,
                    [field]: getEmailValue(row, field),
                }),
                {}
            )
        );
        setEditEmailErrors({});
    };

    const handleEditCancel = () => {
        setEditingRowId(null);
        setEditContactNumber("");
        setEditGrade("");
        setEditStatus("");
        setEditEmailValues({});
        setEditEmailErrors({});
    };

    const handleContactNumberChange = (e) => {
        const digitsOnly = e.target.value.replace(/\D/g, "");
        setEditContactNumber(digitsOnly);
    };

    const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    const handleStoreEmailChange = (field) => (e) => {
        const value = e.target.value.trim();
        setEditEmailValues((prev) => ({
            ...prev,
            [field]: value,
        }));
        setEditEmailErrors((prev) => ({
            ...prev,
            [field]: !value || !isValidEmail(value) ? "Enter a valid email" : "",
        }));
    };

    const handleGetStoreData = useCallback(async () => {
        try {
            if (!formData?.channel) {
                 setSnackBarOpen(true);
                setSnackBar({
                    message:"Please select the channel and try again",
                    severity: "error",
                    anchorOrigin: { horizontal: "center", vertical: "top" },
                });
                return;
            }
            if (!formData?.brand) {
                 setSnackBarOpen(true);
                setSnackBar({
                    message:"Please select the brand and try again",
                    severity: "error",
                    anchorOrigin: { horizontal: "center", vertical: "top" },
                });
                return;
            }
            setLoadingOpen(true);
            const params = new URLSearchParams({
                channel: formData.channel,
                brand: formData.brand,
            });
            const res = await pythonVmInstance.get(`/discount-master/discount-store-master?${params.toString()}`);
            const normalizedRows = (res?.data || []).map((item, index) => ({
                ...item,
                _rowId:
                    item?.store_code ||
                    item?.storeCode ||
                    item?.id ||
                    `row-${index}`,
            }));
            setStoreRows(normalizedRows);
            setLoadingOpen(false);
        } catch (err) {
            const message = err?.response?.data?.message;
            setSnackBarOpen(true);
            setSnackBar({
                message: message || "Unable to fetch approval master data",
                severity: "error",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
            setLoadingOpen(false);
        }
    }, [formData?.brand, formData?.channel, setLoadingOpen, setSnackBar, setSnackBarOpen]);

    const handleStoreDetailsUpdate = async (updatedRow) => {
        try {

            console.log("sajcbkasbckabskjcb", updatedRow)

            const payload = {
                ...updatedRow,
                store_code: updatedRow?.store_code || updatedRow?.storeCode || updatedRow?.id,
                ginesys_short_name: updatedRow?.store_name || updatedRow?.ginesys_short_name,
                channel: (updatedRow?.channel || formData?.channel || "").trim(),
                brand: updatedRow?.brand || formData?.brand,
                updated_by: user.email,
            };

            delete payload._rowId;

            console.log("ascuiabskfbakscbkabsc", payload)
            // setDownloading(true);
            setLoadingOpen(true);
            await pythonVmInstance({
                url: `/discount-master/update-store-master`,data: payload,
                method: "PUT",
            })
            handleGetStoreData();
            setLoadingOpen(false);
        } catch (error) {
            setSnackBarOpen(true);
            setLoadingOpen(false);
            setSnackBar({
                ...snackBar,
                message: "Failed to download file",
                severity: "error",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
        }
    }

    const handleEditSave = () => {
        const rowToUpdate = storeRows.find((item) => item?._rowId === editingRowId);
        if (!rowToUpdate) return;

        const emailFields = getEmailFields();
        const nextErrors = emailFields.reduce((acc, field) => {
            const value = (editEmailValues[field] || "").trim();
            return {
                ...acc,
                [field]: !value || !isValidEmail(value) ? "Enter a valid email" : "",
            };
        }, {});

        if (Object.values(nextErrors).some(Boolean)) {
            setEditEmailErrors(nextErrors);
            return;
        }

        const updatedEmailValues = emailFields.reduce(
            (acc, field) => ({
                ...acc,
                [field]: editEmailValues[field].trim(),
            }),
            {}
        );
        const updatedRow = {
            ...rowToUpdate,
            contact_no: editContactNumber,
            grade: editGrade,
            store_grade: editGrade,
            status: editStatus,
            store_email: updatedEmailValues.email || updatedEmailValues.partner_email,
            ...updatedEmailValues,
        };

        setStoreRows((prev) =>
            prev.map((item) =>
                item?._rowId === editingRowId
                    ? updatedRow
                    : item
            )
        );
        handleStoreDetailsUpdate(updatedRow);
        handleEditCancel();
    };

    const renderEmailCell = (field, placeholder) => (params) =>
        editingRowId === params.row?._rowId ? (
            <TextField
                size="small"
                value={editEmailValues[field] || ""}
                onChange={handleStoreEmailChange(field)}
                placeholder={placeholder}
                error={Boolean(editEmailErrors[field])}
                helperText={editEmailErrors[field]}
            />
        ) : (
            getEmailValue(params.row, field) || "-"
        );

    const storeDetailsColumns = [
            {
                field: "sNo",
                headerName: "S.No",
                width: 70,
                sortable: false,
                filterable: false,
                renderCell: (params) =>
                    filteredRows.findIndex((row) => row?._rowId === params.row?._rowId) + 1,
            },
            {
                field: "ginesys_short_name",
                headerName: "Store Name",
                minWidth: 200,
                flex: 1,
                renderCell: (params) => params.row?.ginesys_short_name || "-",
            },
            formData.channel === "MBO" && {
                field: "partner_site_name",
                headerName: "Partner Name",
                minWidth: 200,
                flex: 1,
                renderCell: (params) => params.row?.partner_site_name || "-",
            },
            {
                field: "channel",
                headerName: "Channel",
                minWidth: 100,
                renderCell: (params) => params.row?.channel || params.row?.channel_name || "-",
            },
            {
                field: "brand",
                headerName: "Brand",
                minWidth: 140,
                renderCell: (params) => params.row?.brand || params.row?.brand_name || "-",
            },
            {
                field: "region",
                headerName: "Zone",
                minWidth: 100,
                renderCell: (params) => params.row?.region || "-",
            },
            {
                field: "state",
                headerName: "State",
                minWidth: 140,
                renderCell: (params) => params.row?.state || params.row?.state_name || "-",
            },
            {
                field: "city",
                headerName: "City",
                minWidth: 140,
                renderCell: (params) => params.row?.city || params.row?.city_name || "-",
            },
            {
                field: "grade",
                headerName: "Store Grade",
                minWidth: 120,
                renderCell: (params) =>
                    editingRowId === params.row?._rowId ? (
                        <TextField
                            size="small"
                            value={editGrade}
                            onChange={(e) => setEditGrade(e.target.value)}
                            placeholder="Store Grade"
                        />
                    ) : (
                        getGradeValue(params.row) || "-"
                    ),
            },
            {
                field: "status",
                headerName: "Store Status",
                minWidth: 120,
                renderCell: (params) =>
                    editingRowId === params.row?._rowId ? (
                        <TextField
                            size="small"
                            value={editStatus}
                            onChange={(e) => setEditStatus(e.target.value)}
                            placeholder="Store Status"
                        />
                    ) : (
                        getStatusValue(params.row) || "-"
                    ),
            },
            {
                field: "contact_no",
                headerName: "Contact Number",
                minWidth: 170,
                renderCell: (params) =>
                    editingRowId === params.row?._rowId ? (
                        <TextField
                            size="small"
                            value={editContactNumber}
                            onChange={handleContactNumberChange}
                            placeholder="Contact Number"
                            inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                        />
                    ) : (
                        getContactValue(params.row) || "-"
                    ),
            },
            formData.channel === "MBO" && {
                field: "partner_email",
                headerName: "Partner Email",
                minWidth: 220,
                flex: 1,
                renderCell: renderEmailCell("partner_email", "Partner Email"),
            },
            formData.channel === "MBO" && {
                field: "nsm_email",
                headerName: "NSM Email",
                minWidth: 220,
                flex: 1,
                renderCell: renderEmailCell("nsm_email", "NSM Email"),
            },
            formData.channel === "MBO" && {
                field: "zm_email",
                headerName: "ZM Email",
                minWidth: 220,
                flex: 1,
                renderCell: renderEmailCell("zm_email", "ZM Email"),
            },
            formData.channel === "MBO" && {
                field: "rm_asm_email",
                headerName: "RM/ASM Email",
                minWidth: 220,
                flex: 1,
                renderCell: renderEmailCell("rm_asm_email", "RM/ASM Email"),
            },
            formData.channel !== "MBO" && {
                field: "email",
                headerName: "Store Email",
                minWidth: 220,
                flex: 1,
                renderCell: renderEmailCell("email", "Store Email"),
            },
            {
                field: "action",
                headerName: "Action",
                width: 150,
                sortable: false,
                filterable: false,
                renderCell: (params) =>
                    editingRowId === params.row?._rowId ? (
                        <Stack direction="row" spacing={1}>
                            <Button size="small" variant="contained" onClick={handleEditSave} disabled={role}>
                                Save
                            </Button>
                            <Button size="small" variant="outlined" onClick={handleEditCancel}>
                                Cancel
                            </Button>
                        </Stack>
                    ) : (
                        <IconButton size="small" onClick={() => handleEditStart(params.row)} disabled={role}>
                            <EditIcon fontSize="small" />
                        </IconButton>
                    ),
            },
        ].filter(Boolean);
    

    const handleFileChange = (e) => {
        const newFile = e.target.files[0];
        if (!newFile) return;

        const modifiedFile = new File([newFile], newFile.name, {
            type: newFile.type,
        });

        setFile(modifiedFile);
    };

    const handleChange = (field) => (e) => {
        setFormData((prev) => ({
            ...prev,
            [field]: e.target.value,
            ...(field === "channel" ? { brand: "" } : {}),
        }));
    };

    const handleDownloadSample = async () => {
        try {
            if (!formData?.channel || !formData?.brand) {
                setSnackBarOpen(true);
                setSnackBar({
                    ...snackBar,
                    message: "Please select channel and brand",
                    severity: "warning",
                    anchorOrigin: { horizontal: "center", vertical: "top" },
                });
                return;
            }
            // setDownloading(true);
            setLoadingOpen(true);
            const params = new URLSearchParams({
                channel: formData.channel,
                brand: formData.brand,
            });
            await pythonVmInstance({
                url: `/discount-master/download-store-master?${params.toString()}`,
                headers: {
                    "Content-Type": "application/json",
                },
                method: "GET",
                responseType: "blob",
            }).then((res) => {
                const url = URL.createObjectURL(res.data);
                FileSaver.saveAs(url, `${formData?.channel}_${formData?.brand}_store_master_sample.csv`);
                setLoadingOpen(false);
            });
        } catch (error) {
            setSnackBarOpen(true);
            setLoadingOpen(false);
            setSnackBar({
                ...snackBar,
                message: "Failed to download file",
                severity: "error",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
        }
    };

    const handleFileUpload = async (e) => {
        e.preventDefault();
        setLoadingOpen(true);
        let form = new FormData();
        if (!formData?.channel || !formData?.brand) {
            setSnackBarOpen(true);
            setSnackBar({
                ...snackBar,
                message: "Please select channel and brand",
                severity: "warning",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
            setLoadingOpen(false);
            return;
        }
        if (file === "") {
            // setLoadingOpen(false);
            setSnackBarOpen(true);
            setSnackBar({
                ...snackBar,
                message: "Please upload some files and try again",
                severity: "warning",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
            setLoadingOpen(false);
            return;
        }

        form.append("files", file);
        form.append("email", user.email);
        form.append("channel", formData?.channel);
        form.append("brand", formData?.brand);
        pythonVmInstance
            .post("/discount-master/upload-store-master", form, { headers: { "Content-Type": "multipart/form-data" } })
            .then((res) => {
                setLoadingOpen(false);
                setSnackBarOpen(true);
                setSnackBar({
                    ...snackBar,
                    message: "Uploaded the files successfully",
                    severity: "success",
                    anchorOrigin: { horizontal: "center", vertical: "top" },
                });
                console.log("sldjlisjdfhasdf", res?.data)
                document.getElementById("fileInput").value = "";
                setFile("")
                handleGetStoreData()
            })
            .catch((err) => {
                console.log("uploaded", err);
                const message = err?.response?.data?.message;
                setLoadingOpen(false);
                setSnackBarOpen(true);
                setSnackBar({
                    ...snackBar,
                    message: message ? message : "Unable to uploaded the files",
                    severity: "error",
                    anchorOrigin: { horizontal: "center", vertical: "top" },
                });
            });
    };

    useEffect(() => {
        if (formData?.channel && formData?.brand){
            handleGetStoreData();
        }
    }, [formData?.brand, formData?.channel, handleGetStoreData]);


    console.log("dsfghjopkhgf", storeRows)

    return (
        <Stack width="98%" p={2} maxHeight={500} spacing={2}>
            <Box display="flex" columnGap={2} mb="16px">
                <Box display="flex" columnGap={2} mb="16px">
                    <TextField
                        select
                        label="Channel"
                        size="small"
                        sx={{ minWidth: 130 }}
                        value={formData.channel}
                        onChange={handleChange("channel")}
                    >
                        {channelOptions.map((item) => (
                            <MenuItem key={item.key} value={item.key}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </TextField>
                </Box>
                <Box display="flex" columnGap={2} mb="16px">
                    <TextField
                        select
                        label="Brand"
                        size="small"
                        sx={{ minWidth: 170 }}
                        value={formData.brand}
                        onChange={handleChange("brand")}
                    >
                        {brandOptions.map((item) => (
                            <MenuItem key={item.key} value={item.key}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </TextField>
                </Box>
                <Box display="flex" justifyContent="flex-end" alignItems="center" flex={1}>
                    <Button variant="contained" onClick={handleGetStoreData}>
                        Get Stores
                    </Button>
                </Box>
            </Box>
            <Box display="flex" columnGap={2} mb="16px">
                <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    width="30%"
                    sx={{ border: "1px solid lightgray" }}
                    padding="5px"
                    borderRadius="4px"
                >
                    <Button
                        variant="outlined"
                        size="small"
                        component="label"
                        sx={{ height: 28, fontSize: "12px", textTransform: "none" }}
                        disabled={role}
                    >
                        Choose File
                        <input
                            type="file"
                            hidden
                            id = "fileInput"
                            accept=".csv,text/csv"
                            onChange={handleFileChange}
                            disabled={role}
                        />
                    </Button>

                    <Typography variant="caption" width="200px" noWrap>
                        {file?.name || "No file chosen"}
                    </Typography>
                </Box>
                <Button variant="contained" disabled={role} onClick={handleFileUpload}>
                    Upload
                </Button>
                <Button variant="contained" disabled={role} onClick={handleDownloadSample}>
                    Download
                </Button>
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <Typography fontWeight={600}>
                    Store Details
                </Typography>
                <TextField
                    size="small"
                    label="Search"
                    placeholder="Store name, grade..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    sx={{ minWidth: 320 }}
                />
            </Box>
            <Box height={320} width="100%">
                <DataGrid
                    rows={filteredRows || []}
                    columns={storeDetailsColumns}
                    getRowId={(row) => row?._rowId}
                    rowHeight={64}
                    columnHeaderHeight={40}
                    disableRowSelectionOnClick
                    pageSizeOptions={[5, 10, 25]}
                    localeText={{
                        noRowsLabel: storeRows?.length ? "No matching stores found" : "No store details found",
                    }}
                    sx={{
                        "& .MuiDataGrid-columnHeader": {
                            background: "#f5f5f5",
                            fontWeight: 600,
                        },
                        "& .MuiDataGrid-cell": {
                            alignItems: "center",
                        },
                    }}
                />
            </Box>

        </Stack>
    );
}

export default DiscountStoreMaster;
